<mat-card>
  <mat-card-title>
    <div flexLayout="row" flexLayoutAlign="space-between center">
      <div *ngIf="props.label && props.hideLabel !== true">{{ props.label }}</div>
      <div flexLayout="row" flexLayoutAlign="end center">
        <button mat-flat-button type="button" color="primary" (click)="add()" *ngIf="!props.disabled">
          {{ addTooltip | memoize: to }}
        </button>
      </div>
    </div>
  </mat-card-title>
  <mat-card-subtitle>
    <div flexLayout="column" flexLayoutAlign="start stretch">
      <div>
        {{ props.description }}
      </div>
      <div class="mat-error" role="alert" *ngIf="showError && formControl.errors">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    </div>
  </mat-card-subtitle>

  <div *ngIf="dataSource && columnDefs" mat-card-image>
    <mat-table
      class="form-field-small"
      [dataSource]="dataSource"
      [style.width.%]="100"
      matSort
      [multiTemplateDataRows]="true"
      [trackBy]="trackByIndex"
    >
      <!--column defs-->
      <ng-container
        *ngFor="let col of columnDefs; trackBy: trackByKey"
        [matColumnDef]="asString(col.key)"
      >
        <mat-header-cell *matHeaderCellDef>{{ col.props?.label }}</mat-header-cell>
        <mat-cell *matCellDef="let row; let dataIndex = dataIndex">
          <formly-field [field]="getField | memoize: field:col:dataIndex"></formly-field>
        </mat-cell>
      </ng-container>

      <!--action column def-->
      <ng-container matColumnDef="actions" *ngIf="!props.disabled">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell
          *matCellDef="let row; let dataIndex = dataIndex"
          flexLayout="row"
          flexLayoutAlign="end center"
        >
          <button
            mat-icon-button
            type="button"
            (click)="remove(dataIndex)"
            *ngIf="!props.disabled"
            [matTooltip]="removeTooltip | memoize: dataIndex:model"
          >
            <mat-icon color="warn">delete_forever</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!--header output-->
      <mat-header-row
        *matHeaderRowDef="getColumns | memoize: columnKeys:props.disabled"
      ></mat-header-row>

      <!--body output-->
      <mat-row
        *matRowDef="let row; columns: getColumns | memoize: columnKeys:props.disabled"
        flexLayout="row"
        flexLayoutAlign="start center"
      ></mat-row>
    </mat-table>
  </div>
</mat-card>
